export default "__VITE_ASSET__DxfTKzPm__"